import React, { Component } from 'react';
import { ROUTES } from '@solarwindscloud/sso-nighthawk-shared';
import { Link } from 'react-router-dom';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';
import { Header, Divider } from '@solarwindscloud/nighthawk-ui';

export const dataTestIds = {
  invalidInvitation: 'invalid-invitation',
  linkToSignup: 'link-to-signup',
};

export default class InvalidInvitation extends Component {
  render() {
    return (
      <UnifiedLayout headerText="Invalid or Expired Invitation Link">
        <Header textAlign="center">
          <Header.Subheader data-test-id={dataTestIds.invalidInvitation}>
            Your invitation link is invalid or has expired. <br />
            Talk to your administrator for more information.
            <Divider hidden />
            If you want to try our product without a team <br />
            you can{' '}
            <Link to={{ pathname: ROUTES.EXTERNAL_SIGN_UP }}>
              <span data-test-id={dataTestIds.linkToSignup}>sign up here</span>
            </Link>
          </Header.Subheader>
        </Header>
      </UnifiedLayout>
    );
  }
}
